<template>
  <div id="Jishikaijiang">
    <div class="tr-header">
      <p class="title">开奖记录</p>
      <div class="handles">
        <div v-if="betType != 'xyrb' && betType != 'ks' && betType != 'three'">
          <span
            class="handle"
            @click="showDoubl()"
            :class="{ active: moreTable.double }"
            >今日双面/号码统计</span
          >
          <span
            class="handle"
            @click="moreTable.long = !moreTable.long"
            :class="{ active: moreTable.long }"
            >长龙提醒</span
          >
          <span
            class="handle"
            @click="moreTable.handle = !moreTable.handle"
            :class="{ active: moreTable.handle }"
            >号码分析</span
          >
        </div>
        <div
          :class="device == 'mobile' ? 'handle' : 'handle end'"
          @click="gotoHistory"
        >
          开奖历史
        </div>
      </div>
    </div>
    <div class="tr-header-container">
      <transition
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft"
        mode="out-in"
      >
        <div class="handle-con" v-if="moreTable.double">
          <p class="title">今日双面统计</p>
          <Table
            stripe
            border
            :data="doubleStatis1"
            :columns="doubleStatisColumns1"
          ></Table>
          <Table
            stripe
            border
            :data="doubleStatis2"
            :columns="doubleStatisColumns2"
            style="margin-top: 20px;"
          ></Table>
        </div>
      </transition>

      <transition
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft"
        mode="out-in"
      >
        <div class="handle-con" v-if="moreTable.long">
          <p class="title">长龙连开提醒</p>
          <ul class="longQueue" v-if="longQueueContinue.length">
            <li v-for="(it, i) in longQueueContinue" :key="i">
              <span>{{ it.name }}:</span>
              <span>{{ it.type }}</span>
              <span :class="{ red: it.value >= 5 }">{{ it.value }}</span>
              <span>期</span>
            </li>
          </ul>
        </div>
      </transition>

      <transition
        enter-active-class="animated fadeInLeft"
        leave-active-class="animated fadeOutLeft"
        mode="out-in"
      >
        <div class="handle-con" v-if="moreTable.handle">
          <div class="title">
            <span>查看球号分布：</span>
            <div class="handles" style="display:inline-block;">
              <span
                class="handle"
                v-for="i in 10"
                v-if="betType == 'ssc'"
                :key="i"
                @click="handleSelectType(0, i - 1)"
                :class="{
                  active: selectType === 0 && ~selectNumArr.indexOf(i - 1)
                }"
                >号码{{ i - 1 }}</span
              >
              <span
                class="handle"
                v-for="i in 20"
                v-if="betType == 'hpten'"
                :key="i"
                @click="handleSelectType(0, i)"
                :class="{
                  active: selectType === 0 && ~selectNumArr.indexOf(i)
                }"
                >号码{{ i }}</span
              >
              <span
                class="handle"
                v-for="i in 11"
                v-if="betType == 'choose5'"
                :key="i"
                @click="handleSelectType(0, i)"
                :class="{
                  active: selectType === 0 && ~selectNumArr.indexOf(i)
                }"
                >号码{{ i }}</span
              >
              <span
                class="handle"
                v-for="i in 10"
                v-if="betType == 'PK10' || betType == 'nn'"
                :key="i"
                @click="handleSelectType(0, i)"
                :class="{
                  active: selectType === 0 && ~selectNumArr.indexOf(i)
                }"
                >号码{{ i }}</span
              >
            </div>
          </div>
          <div class="title">
            <span>大小单双分布：</span>
            <div class="handles" style="display:inline-block;">
              <span
                class="handle"
                @click="handleSelectType(1, 0)"
                :class="{ active: selectType === 1 && selectValue === 0 }"
                >单</span
              >
              <span
                class="handle"
                @click="handleSelectType(1, 1)"
                :class="{ active: selectType === 1 && selectValue === 1 }"
                >双</span
              >
              <span
                class="handle"
                @click="handleSelectType(2, 0)"
                :class="{ active: selectType === 2 && selectValue === 0 }"
                >大</span
              >
              <span
                class="handle"
                @click="handleSelectType(2, 1)"
                :class="{ active: selectType === 2 && selectValue === 1 }"
                >小</span
              >
              <span
                class="handle"
                @click="handleSelectType(3, 0)"
                :class="{ active: selectType === 3 && selectValue === 0 }"
                >对子号</span
              >
              <span class="handle reset" @click="handleSelectType('', '')"
                >还原</span
              >
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div class="tr-table-container">
      <Table
        :columns="columns"
        :loading="loading"
        :data="dataSource"
        stripe
        border
      ></Table>

      <div class="page">
        <Page :total="total" :page-size="50" @on-change="handleMoreData" />
        <!-- <Button type="primary" :loading="loading" :disabled="noMore" @click="handleMoreData">
          <span v-if="!loading">{{loadingTxt}}</span>
          <span v-else>加载中...</span>
        </Button>-->
      </div>
    </div>
  </div>
</template>
<script>
import columns from "./columns";
import dayjs from "dayjs";

import statistic from "../../../helpers/statistic";
import { mapState } from "vuex";
export default {
  name: "Jishikaijiang",
  data() {
    return {
      columns: [],
      dataSource: [],
      moreTable: {
        double: false,
        long: false,
        handle: false
      },
      noMore: false,
      loadingTxt: "加载更多",
      loading: false,
      pageSize: 50,
      startRow: 0,
      total: 0,
      gameType: this.$route.params.gameType,
      doubleStatisColumns1: [],
      doubleStatisColumns2: [],
      tableShowBallType: 0, // 0 显示号码 1 显示大小 2显示单双
      selectType: "", //0号码 1单双 2大小 3对子号
      selectNumArr: [], //0号码可以多选
      selectValue: "", //0-9    01    01     0
      doubleStatisData: [],
      doubleStatis1: []
    };
  },
  computed: {
    ...mapState(["device"]),
    betType() {
      return this.$route.params.betType;
    },

    doubleStatis2() {
      let obj = statistic.getNumPattern(
        this.$route.params.betType,
        this.dataSource
      );
      obj.title = "出现次数";
      return [obj];
    },

    longQueueContinue() {
      const arr = statistic.getLongQueueContinue(
        this.$route.params.betType,
        this.dataSource
      );
      return arr;
    }
  },
  created() {
    this.reset();
  },
  methods: {
    init() {
      this.getData();
    },
    //更多
    async handleMoreData(page) {
      this.loading = true;
      this.startRow = (page - 1) * 50;
      await this.getData("push");
      this.loading = false;
    },

    showDoubl() {
      if (!this.moreTable.double) {
        this.queryKcDateReport();
      }
      this.moreTable.double = !this.moreTable.double;
    },
    async queryKcDateReport() {
      let { data } = await this.$http.post("/queryKcDateReport.do", {
        gameType: this.$route.params.gameType,
        date: dayjs(new Date()).format("YYYY-MM-DD")
      });
      if (data.returnCode == "0000") {
        let obj = statistic.getDoubleDiscData(
          this.$route.params.betType,
          data.returnList[0]
        );
        obj.title = "出现次数";
        this.doubleStatis1 = [obj];
      }
    },
    reset() {
      this.columns = columns(this.betType, this.gameType).list(this);
      this.moreTable = {
        double: false,
        long: false,
        handle: false
      };
      this.tableShowBallType = 0;
      this.selectType = "";
      this.selectNumArr = [];
      this.selectValue = "";
      if (this.betType != "three") {
        this.doubleStatisColumns1 = columns(this.betType).doubleStatisColumns1;
        this.doubleStatisColumns2 = columns(this.betType).doubleStatisColumns2;
      }
    },
    async getData(type) {
      let res = await this.$http.post("/queryGameTypeResultByGameType.do", {
        gameType: this.$route.params.gameType,
        pageSize: this.pageSize,
        startRow: this.startRow,
        startDate: dayjs(new Date()).format("YYYYMMDD"),
        endDate: dayjs(new Date()).format("YYYYMMDD")
      });
      if (res.data.returnCode == "0000") {
        this.total = res.data.totalCount;

        this.dataSource = res.data.returnList;
      } else {
        this.$Message.error(res.data.returnMessage);
      }
      if (this.betType == "three") {
        let lhcReq = {
          gameType: this.$route.params.gameType,
          isNeed: 1,
          num: 30,
          date: dayjs().format("YYYY-MM-DD")
        };
        let lhcData = await this.$http.post("/queryKcReportByIssue.do", lhcReq);
        if (lhcData.data.returnCode == "0000") {
          this.total = lhcData.data.totalCount;

          this.dataSource = lhcData.data.returnList;
        } else {
          this.$Message.error(res.data.returnMessage);
        }
      }
    },
    handleSelectType(type, value) {
      if (type === 0) {
        this.selectType = 0;
        this.selectValue = "";
        const idx = this.selectNumArr.indexOf(value); //选择号码是否已存在筛选中
        if (~idx) {
          //号码已存在筛选中则移除
          this.selectNumArr.splice(idx, 1);
          if (this.selectNumArr.length == 0) {
            this.selectType = "";
          }
        } else {
          this.selectNumArr.push(value);
        }
      } else {
        this.selectNumArr = [];
        if (this.selectValue === value && this.selectType === type) {
          this.selectValue = "";
          this.selectType = "";
        } else {
          this.selectType = type;
          this.selectValue = value;
        }
      }
    },
    gotoHistory() {
      this.$router.push(
        `/Trend/${this.$route.params.betType}/${this.$route.params.gameType}/?modeType=History`
      );
    }
  }
};
</script>
<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/Trend/Jishikaijiang/index.vue